import { createSelector } from 'reselect'

const getAuthProfile = (state: any) => state.oidc && state.oidc.user && state.oidc.user.profile

const PARTNER_IDP = 'bca'

export default createSelector(getAuthProfile, (profile) => profile && profile.idp === PARTNER_IDP)
